<script>
    export let alert = "";
    export let type = "success";
</script>

{#if alert}
    <div class="alert alert-{type}" role="alert">
        <button
            type="button"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
            on:click={() => (alert = "")}
            ><span aria-hidden="true">&times;</span></button
        >
        {alert}
    </div>
{/if}

<style>
    .alert {
        margin-top: 20px;
    }
</style>
